module.exports = __webpack_public_path__ + "static/media/0004.119f9515.jpg";